import {NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';

import { EmisionCfeRoutingModule } from './emision-cfe-routing.module';
import {EmisionCfeComponent} from './emision-cfe.component';
import { MatButtonModule } from '@angular/material/button';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatCardModule} from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  MatDatepickerModule,
  MatFormFieldModule,
  MatMenuModule,
  MatSidenavModule,
  MatInputModule,
  MatNativeDateModule,
  MatSelectModule,
  MatRadioModule,
  MatExpansionModule,
  MatGridListModule,
  MatTableModule,
  MatDialogModule,
  MatIconModule,
  MatProgressSpinnerModule,
  MatListModule,
  MatTooltipModule
} from '@angular/material';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IdentificacionComponent} from '../../components/identificacion/identificacion.component';
import {EmisorComponent} from '../../components/emisor/emisor.component';
import {ReceptorComponent} from '../../components/receptor/receptor.component';
import {TotalesComponent} from '../../components/totales/totales.component';
import {DetallesComponent} from '../../components/detalles/detalles.component';
import {AdendaComponent} from '../../components/adenda/adenda.component';
import {HttpClientModule} from '@angular/common/http';
import {EmisionCfeResolver} from '../../resolvers/emision-cfe-resolver';
import {ReferenciasComponent} from '../../components/referencias/referencias.component';
import {NumberDirective} from '../../directives/number.directive';
import {SharedModule} from '../../modules/shared/shared.module';
import {MatAutocompleteModule} from '@angular/material/autocomplete';

@NgModule
({
  declarations:
  [
    EmisionCfeComponent,
    IdentificacionComponent,
    EmisorComponent,
    ReceptorComponent,
    TotalesComponent,
    DetallesComponent,
    AdendaComponent,
    ReferenciasComponent
  ],
  imports:
  [
    CommonModule,
    EmisionCfeRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatButtonModule,
    MatToolbarModule,
    MatCardModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatMenuModule,
    MatSidenavModule,
    MatInputModule,
    MatNativeDateModule,
    MatSelectModule,
    MatRadioModule,
    MatExpansionModule,
    MatGridListModule,
    MatTableModule,
    MatDialogModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatListModule,
    SharedModule,
    MatAutocompleteModule
  ],
  exports:
  [
    IdentificacionComponent,
    EmisorComponent,
    ReceptorComponent,
    DetallesComponent,
    TotalesComponent,
    AdendaComponent,
    ReferenciasComponent
  ],
  providers:
  [
    EmisionCfeResolver,
    NumberDirective
  ]
})
export class EmisionCfeModule
{

}
